// The shared green surface behind the app bar and the drawer header.

export const BRAND_GREEN = "rgb(0, 149, 61)";

// A wash rather than a colour ramp. The brand green stays the real background
// and this only shades it, so the bar cannot drift off-brand however the
// gradient is tuned.
//
// Two stops and a deliberately narrow range: the welcome card's three-stop ramp
// is built for a tall panel, and compressed into a 65px bar its bright midpoint
// lands as a horizontal streak across the width rather than as depth. Light
// from above, shadow below, ~7% either side of the base colour.
//
// The shadow end is a deep green-black rather than neutral black, which would
// desaturate the bottom edge towards grey.
//
// Vertical so the band stays continuous where the drawer header meets the bar
// on the pinned layout: both are the same height and start at the same y, so
// both render an identical ramp and the seam stays invisible.
export const BRAND_GRADIENT =
    "linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0%, rgba(0, 40, 16, 0.1) 100%)";

export const BRAND_HAIRLINE = "1px solid rgba(0, 68, 28, 0.28)";
